// extracted by mini-css-extract-plugin
export var explainable = "_ir-a";
export var printerCard = "_ir-1";
export var printerCardConfigured = "_ir-2";
export var printerCardError = "_ir-3";
export var printerCardsContainer = "_ir-0";
export var printerIcon = "_ir-8";
export var printerIconConfigured = "_ir-5";
export var printerIconContainer = "_ir-4";
export var printerIconError = "_ir-6";
export var printerIconUnconfigured = "_ir-7";
export var workstationsTableCard = "_ir-9";